import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ClaimsListService extends Subject<DataStateChangeEventArgs>{
  claimWithoutBatch: any = [];
  constructor(private http: HttpClient, public errorService: ErrorService,
     public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public outputValues(state): void {
    this.getClaimsList(state).subscribe(x => super.next(x));
  }
  getClaimsList(state?): Observable<DataStateChangeEventArgs> {
    this.claimWithoutBatch = [];
    return this.http.post<any>("api/ClaimMaster/getClaims", state)
      .pipe(map(
        (response: any) =>
        (<any>{
          idList: response['allIds'],
          result: response['result'],
          count: response['count']
        }
        )
      )).pipe(map((e: any) => {
        e.result.forEach(element => {
          element.underBilled= (element.underbilled == true)? "YES":"NO";
        });
        return e;
      })
      )
  }

  getClaimdata() {
    return this.claimWithoutBatch;
  }
}
